import { useState } from 'react';
import './ZoomableImg.scss'
import ProgressiveImg from './ProgressiveImg';

type Props = {
    src: string;
}

const ZoomableImg: React.FC<Props> = ({ src }) => {
    const [backgroundPosition, SetBackgroundPosition] = useState('0% 0%')
    const handleMouseMove = (e: any) => {
        const { left, top, width, height } = e.target.getBoundingClientRect()
        const x = (e.pageX - left) / width * 100
        const y = (e.pageY - top) / height * 100
        SetBackgroundPosition(`${x}% ${y}%`)
    }
    return (
        <figure onMouseMove={handleMouseMove} className='zoomable' style={{ backgroundImage: `url(${src})`, backgroundPosition }}>
            <ProgressiveImg
                src={src} 
            />
        </figure>
    );
};

export default ZoomableImg;
